class promoBar extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.promoBar = this.querySelector(".promo-bar");
    this.closeButton = this.querySelector(".promo-bar__close");
  }

  connectedCallback() {
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleClose();
    });
    this.handleInitialize();
  }
  handleClose() {
    this.promoBar.setAttribute("aria-hidden", "true");
    sessionStorage.setItem("show_promobar", false);
    this.promoBar.classList.add("hidden");
  }
  handleInitialize() {
    let isHidden = sessionStorage.getItem("show_promobar");
    if (isHidden != "false") {
      this.promoBar.classList.remove("hidden");
      this.promoBar.setAttribute("aria-hidden", "false");
      return;
    }
  }
}

if (!customElements.get("promo-bar")) {
  customElements.define("promo-bar", promoBar);
}
